import { Controller } from '@hotwired/stimulus';

/**
 * Extra unlock buttons for the bold free CTA (winner of A/B tool_free_cta_v3): they open the same sign-up
 * dialog as the main button. With sticky: true the element is a bottom bar shown only
 * while the main button has scrolled up out of view.
 */
export default class extends Controller {
  static values = { sticky: Boolean };

  connect() {
    if (!this.stickyValue) return;

    this.main = this.findMainButton();
    if (!this.main || typeof IntersectionObserver !== 'function') return;

    this.observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.element.hidden = !scrolledPast;
    });
    this.observer.observe(this.main);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  open(event) {
    event?.preventDefault();
    const host = document.querySelector('[data-controller~="tool-signup-dialog"]');
    const dialog = host && this.application.getControllerForElementAndIdentifier(host, 'tool-signup-dialog');
    if (dialog) {
      dialog.open();
    } else {
      this.findMainButton()?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // The visible main button (the hidden A/B variant's copy has no layout box).
  findMainButton() {
    return [...document.querySelectorAll('.tool-unlock-cta .tool-unlock-cta__free-btn')].find(
      (button) => button.getClientRects().length > 0,
    );
  }
}
